import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import type { PopupData, RecordData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import UserInviteComponent from 'webapp/components/user/invite';

export default class UserPopupInviteComponent extends PopupInnerModalComponent<PopupData.User.UserInvite> {
	@tracked showTitle = true;

	@action
	hideTitle() {
		this.showTitle = false;
	}

	@action
	onUserInvited(users: RecordData.User.Raw[]) {
		this.popupData.onUserInvited?.(users);
	}

	<template>
		<div>
			{{#if this.showTitle}}
				<div class="title">
					<CommonUiIconComponent @name="UserNew" @size="lg" />
					Invite new users
				</div>
			{{/if}}
			<div class="content">
				<UserInviteComponent
					@initialNumberOfNewUsers={{2}}
					@maximumNumberOfNewUsers={{this.popupData.maximumNumberOfNewUsers}}
					@onAdminInvite={{this.close}}
					@onNonAdminInvite={{this.hideTitle}}
					@onClose={{this.close}}
					@onContentChange={{this.scheduleReposition}}
					@trackingOrigin={{this.popupData.trackingOrigin}}
					@onUserInvited={{this.onUserInvited}}
					@ignoreEmptyFields={{true}}
				/>
			</div>
		</div>
	</template>
}
